/**
 * Dashboard /support tab — static help panel.
 *
 * Originally lines 1147-1172 of `routes/dashboard.ts`. Phase 2.2.
 */
import { escapeHtml } from '../../utils';
import { icon } from '../../utils/icons';
import { t } from '../../i18n';

export function supportPanel(): string {
  // TG and Email cards carry data-support-action so the click handler in
  // mount() can swap the href with a MSISDN-prefilled template just-in-time.
  // We render baseline (no-prefill) URLs as fallback in case eSIMs haven't
  // loaded yet — clicking always works, MSISDN just won't appear in those
  // edge cases. Operator decision 2026-05-08: show user's eSIM ID up-front
  // in the support thread so they don't have to dig for it.
  return `
<h2 class="dash-h2">${escapeHtml(t('dash.support.title'))}</h2>
<p class="dash-sub" data-i18n="dash.support.sub">${escapeHtml(t('dash.support.sub'))}</p>
<div class="dash-support">
  <a class="dash-support__card" data-support-action="tg" href="https://t.me/roamzy_support_bot" target="_blank" rel="noopener">
    <span class="dash-support__icon" aria-hidden="true">${icon('send', 22)}</span>
    <div><h3>${escapeHtml(t('dash.support.tgTitle'))}</h3><p data-i18n="dash.support.tgSub">${escapeHtml(t('dash.support.tgSub'))}</p></div>
  </a>
  <a class="dash-support__card" data-support-action="email" href="mailto:support@roamzy.io">
    <span class="dash-support__icon" aria-hidden="true">${icon('mail', 22)}</span>
    <div><h3>${escapeHtml(t('dash.support.emailTitle'))}</h3><p data-i18n="dash.support.emailSub">${escapeHtml(t('dash.support.emailSub'))}</p></div>
  </a>
  <a class="dash-support__card" href="/faq">
    <span class="dash-support__icon" aria-hidden="true">${icon('question', 22)}</span>
    <div><h3>${escapeHtml(t('dash.support.faqTitle'))}</h3><p data-i18n="dash.support.faqSub">${escapeHtml(t('dash.support.faqSub'))}</p></div>
  </a>
</div>`;
}

